import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import { TypeGrade } from '../../../../types';

interface IProps {
    gradeFilter?: boolean;
    selectedGrade: TypeGrade;
    grade: TypeGrade[];
    changeSchoolFilters: (e: TypeGrade) => void;
};

function GradeFilter({
    gradeFilter,
    selectedGrade,
    grade,
    changeSchoolFilters
}: IProps) {

    const [gradeDropdownOpen, setGradeDropdownOpen] = useState(false);
    const gradeTypeToggle = () => setGradeDropdownOpen(prevState => !prevState);

    return (
        <React.Fragment>
            {gradeFilter ? <Dropdown size="sm" isOpen={gradeDropdownOpen} direction="down" toggle={gradeTypeToggle}>
                <DropdownToggle caret>
                    {selectedGrade ? <span>Grade: <span className="text-primary text-capitalize">{selectedGrade?.name}</span></span> : 'Grade: All'}
                </DropdownToggle>
                <DropdownMenu>
                    {
                        grade?.length !== 0 ? grade?.map((each: TypeGrade, index) => (
                            <DropdownItem key={index} onClick={() => changeSchoolFilters(each)}>
                                <span className="d-flex justify-content-between align-items-center">
                                    {each?.name}
                                    {selectedGrade?.id === each?.id && <i className="fas fa-check-circle text-primary"></i>}
                                </span>
                            </DropdownItem>
                        )) : <span className="small text-muted text-center">Couldn't load grades</span>
                    }
                </DropdownMenu>
            </Dropdown> : <></>}
        </React.Fragment>
    )
}

export default React.memo(GradeFilter);